/**
 * Demo-only account data layer for the Sentry auto-fix demo (/demo/sentry-crash).
 *
 * Mimics how the app loads + shapes account data across two functions so the
 * crash has a real, cross-file data flow to trace (not a one-liner throw).
 * UNLINKED from the product — used solely to demonstrate the sentry-triage
 * auto-fix agent end-to-end.
 */

// Returns a freshly authenticated account. On a fresh session the optional
// `preferences` block has NOT been hydrated yet — the real app lazy-loads it
// after first paint — so it is intentionally absent here.
export function loadDemoAccount() {
  return {
    id: 'acct_demo_001',
    profile: {
      displayName: 'Ada Lovelace',
      email: 'ada@zibby.dev',
      // NOTE: `preferences` is loaded asynchronously elsewhere and is not
      // guaranteed to be present when this account is first read.
    },
  };
}

// Builds the one-line banner the demo page renders for the current account.
export function summarizeAccount(account) {
  // BUG: assumes `account.profile.preferences` is always hydrated. On a fresh
  // session it is undefined, so reading `.theme` throws:
  //   "Cannot read properties of undefined (reading 'theme')"
  const theme = account.profile.preferences.theme;
  return `${account.profile.displayName} · ${theme} mode`;
}
